import React from 'react';
import SMPlanHelper from 'components/helpers/SMPlanHelper';
import sprintf from 'sprintf';
import SMRoomResource from 'resources/SMRoomResource';

class SMStayReservationCalendarBaseView extends React.Component {

  constructor(props) {
    super(props);

    if (props.calendarState) {
      const calendarState = props.calendarState;
      this.state = {
        checkinCalendars: calendarState.checkinCalendars,
        checkoutCalendars: calendarState.checkoutCalendars,
        selectedDate: calendarState.selectedDate,
        year: calendarState.year,
        month: calendarState.month,
        day: calendarState.day,
        isCheckinCalendar: calendarState.isCheckinCalendar,
        checkinAt: calendarState.checkinAt,
        checkoutAt: calendarState.checkoutAt,
      };
    } else {
      const date = new Date();

      this.state = {
        checkinCalendars: [],
        checkoutCalendars: [],
        selectedDate: null,
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: null,
        isCheckinCalendar: true,
        checkinAt: null,
        checkoutAt: null
      };
    }

    this.dayDidSelect = this.dayDidSelect.bind(this);
    this.checkinButtonDidClick = this.checkinButtonDidClick.bind(this);
    this.checkoutButtonDidClick = this.checkoutButtonDidClick.bind(this);
    this.prevMonth = this.prevMonth.bind(this);
    this.nextMonth = this.nextMonth.bind(this);
  }

  componentDidMount() {
    if (!this.props.calendarState) {
      this.today();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevState.checkinAt != this.state.checkinAt) || (prevState.checkoutAt != this.state.checkoutAt)) {
      if (this.props.delegate && typeof this.props.delegate.saveCalendarState === 'function') {
        this.props.delegate.saveCalendarState(this.state);
      }
    }

    // 宿泊カレンダー選択後に同じプランを選んだ場合に予約リクエストへ進めなくならないようにカレンダー情報をクリアする
    // カレンダ情報はプラン選択時にクリアする
    if (prevProps.calendarState != this.props.calendarState) {
      if (this.props.calendarState == null || this.props.calendarState == '') {
        this.setState({
          isCheckinCalendar : true,
          checkinAt: null,
          checkoutAt: null
        });
        this.today();
      }
    }
  }

  componentWillReceiveProps(prevProps, prevState) {
    if (prevProps.plan != this.props.plan || prevProps.isHourly != this.props.isHourly) {
      this.setState({
        isCheckinCalendar : true,
        checkinAt: null,
        checkoutAt: null
      });

      this.today();
    }
  }

  requestMonthlyResource(date, checkinAt, isCheckinCalendar) {
    const plan = this.props.plan;

    let queries = SMPlanHelper.isRoom(plan) ? {} : {plan_id: plan.id};
    queries.year = date.getFullYear();
    queries.month = date.getMonth() + 1;
    if (checkinAt) {
      queries.stay_checkin_at = checkinAt;
    }
    queries.is_checkin_calendar = isCheckinCalendar;
    //$("body").animate({scrollTop: $(this.refs.calendarContainer).offset().top - 80}, 500);
    $(this.refs.calendarContainer).startLoading();
    SMRoomResource.getCalendar(this.props.room.id, queries, (calendars, error)=>{
      $(this.refs.calendarContainer).stopLoading();
      if(!error) {
        if (isCheckinCalendar) {
          this.setState({
            checkinCalendars: calendars,
            year: queries.year,
            month: queries.month,
          });
          $("body").animate({scrollTop: $(this.refs.calendarContainer).offset().top - 80}, 500);
        } else {
          this.setState({
            checkoutCalendars: calendars,
            year: queries.year,
            month: queries.month,
          });
        }
      }
    });
  }

  toYMD(date, divider) {
    divider = divider || "";
    var y = date.getUTCFullYear(),
        m = date.getUTCMonth() + 1,
        d = date.getUTCDate();
    return sprintf("%04d%s%02d%s%02d", y, divider , m , divider , d);
  }

  nextMonth(e) {
    e.preventDefault();
    const isCheckinCalendar = this.state.isCheckinCalendar;
    const date = new Date(
      this.state.year,
      this.state.month,
      1
    );
    let checkinAt = null;
    if (!isCheckinCalendar && this.state.checkinAt){
      checkinAt = this.state.checkinAt;
    }
    this.requestMonthlyResource(date, checkinAt, isCheckinCalendar);
  }

  prevMonth(e) {
    e.preventDefault();
    const isCheckinCalendar = this.state.isCheckinCalendar;
    const date = new Date(
      this.state.year,
      this.state.month - 2,
      1
    );
    let checkinAt = null;
    if (!isCheckinCalendar && this.state.checkinAt){
      checkinAt = this.state.checkinAt;
    }
    this.requestMonthlyResource(date, checkinAt, isCheckinCalendar);
  }

  today(e) {
    if (e) e.preventDefault();
    const date = new Date();
    this.requestMonthlyResource(date, null, true);
  }

  dayDidSelect(calendar, e) {
    e.preventDefault();
    const isCheckinCalendar = this.state.isCheckinCalendar;
    const plan = this.props.plan;

    // チェックインとチェックアウトの日が同じなら、何もしない
    if (!isCheckinCalendar) {
      const selectedDay = new Date(this.state.year, this.state.month - 1, calendar.day, 0, 0, 0);
      const d =  new Date(this.state.checkinAt);
      const checkinDay = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 0, 0, 0);
      if (selectedDay.getTime() == checkinDay.getTime()) {
        return false;
      }
    }

    let selectedAt = "";
    const checkinHour = calendar.checkin_enable;
    const checkoutHour = plan.has_extra_stay_checkinout_hour ?
      plan.extra_stay_checkout_hour : this.props.room.stay_checkout_hour;

    if (isCheckinCalendar) {
      selectedAt = new Date(Date.UTC(this.state.year, this.state.month - 1, calendar.day, checkinHour));
    } else {
      selectedAt = new Date(Date.UTC(this.state.year, this.state.month - 1, calendar.day, checkoutHour));
    }

    if (isCheckinCalendar) {
      let duration = 60 * ((24 + checkoutHour) - checkinHour);
      this.setState({
        isCheckinCalendar: !isCheckinCalendar,
        checkinAt: selectedAt.toISOString(),
        checkoutAt: null
      });
      this.requestMonthlyResource(selectedAt, selectedAt.toISOString(), !isCheckinCalendar);
      if(this.props.delegate && typeof this.props.delegate.stayScheduleDidSelect === 'function'){
        this.props.delegate.stayScheduleDidSelect(selectedAt, duration, isCheckinCalendar, checkinHour);
      }
    } else {
      let checkinAt = Date.parse(this.state.checkinAt);
      let checkoutAt = Date.parse(selectedAt.toISOString());
      let duration = (checkoutAt - checkinAt) / (1000 * 60);
      this.setState({
        checkoutAt: selectedAt.toISOString()
      });
      if(this.props.delegate && typeof this.props.delegate.stayScheduleDidSelect === 'function'){
        this.props.delegate.stayScheduleDidSelect(selectedAt, duration, isCheckinCalendar);
      }
      if(this.props.delegate && typeof this.props.delegate.validateReservation === 'function'){
        this.props.delegate.validateReservation();
      }
    }
  }

  checkinButtonDidClick(e) {
    if (!this.state.checkinAt) {
      $("body").animate({scrollTop: $(this.refs.calendarContainer).offset().top}, 500);
    }

    this.setState({
      isCheckinCalendar : true,
      checkinAt: null,
      checkoutAt: null
    });

    const date = new Date(
      this.state.year,
      this.state.month - 1,
      1
    );

    if(this.props.delegate && typeof this.props.delegate.resetStayReservation === 'function'){
      this.props.delegate.resetStayReservation();
    }

    if (this.state.checkinAt) {
      this.requestMonthlyResource(date, null, true);
    }
  }

  checkoutButtonDidClick(e) {
    if (!this.state.checkoutAt) {
      return;
    };
    this.setState({isCheckinCalendar : false});
  }

}
export default SMStayReservationCalendarBaseView;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMStayReservationCalendarBaseView.jsx